import type { HighPrecisionMonotonicClock } from '../types/highPrecisionMonotonicClock';

export class Timer {
  state : Record<string, TimerState> = { };
  constructor(private clock: HighPrecisionMonotonicClock) { }

  start(category: string) {
    const state = this.state[category];
    const currentStart = this.clock.highPrecisionMonotonicNow();
    if (state === undefined) {
      this.state[category] = { total: 0, currentStart, count: 0 };
    } else {
      if (state.currentStart !== null) {
        throw new Error('Timer already running');
      }
      state.currentStart = currentStart;
    }
  }

  end(category: string) {
    const state = this.state[category];
    if (state === undefined) {
      throw new Error('No such timer');
    }
    if (state.currentStart === null) {
      throw new Error('Timer not running');
    }
    state.total += Number(this.clock.highPrecisionMonotonicNow() - state.currentStart);
    state.currentStart = null;
    state.count += 1;
  }

  report(): string {
    return Object.entries(this.state).map(([category, state]) => {

      return `${category}[e=${niceTime(state.total)}, c=${state.count}, d=${niceTime(state.total / state.count)}]`;
    }).join(', ');
  }
}

function niceTime(nanoSeconds: number): string {
  const units = ['ns', 'μs', 'ms', 's'];
  let unitIndex = 0;
  let time = nanoSeconds;
  while ((time > 10000) && (unitIndex < units.length - 1)) {
    time /= 1000.0;
    unitIndex += 1;
  }
  return `${time.toFixed(1)}${units[unitIndex]}`;
}

interface TimerState {
  count: number;
  // Total number of nano seconds elapsed
  total: number;
  // Current timer start
  currentStart: bigint | null
}
